import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const feedbackKindSchema = z.enum(["GENERAL", "NPS_FOLLOWUP", "EXIT_SURVEY", "BUG_REPORT"]);
export type FeedbackKind = z.infer<typeof feedbackKindSchema>;

export const feedbackStatusSchema = z.enum(["NEW", "READ", "REPLIED", "RESOLVED", "ARCHIVED"]);
export type FeedbackStatus = z.infer<typeof feedbackStatusSchema>;

export const feedbackSchema = z.object({
  id: z.string(),
  userId: z.string().nullable(),
  email: z.string().nullable(),
  kind: feedbackKindSchema,
  status: feedbackStatusSchema,
  rating: z.number().int().nullable(),
  message: z.string(),
  surface: z.string(),
  context: z.record(z.unknown()).nullable(),
  tags: z.array(z.string()),
  adminNote: z.string().nullable(),
  repliedAt: z.string().nullable(),
  repliedById: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  // Joined for admin list/detail when the userId resolves to an active user.
  user: z
    .object({
      id: z.string(),
      name: z.string(),
      email: z.string(),
      picture: z.string().nullable().optional(),
    })
    .nullable()
    .optional(),
});

export class FeedbackDto extends createZodDto(feedbackSchema) {}
export type FeedbackPayload = z.infer<typeof feedbackSchema>;
